"use client";
import { styled } from "@mui/material/styles";
import { SpaceXs, ColorGray900, SizeBorderWidthThin, ColorGray200, FontWeightBold, FontSize600, SpaceMd, SpaceLg, ColorWhite, ColorGray100 } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
const CategoryContainerStyles = {
  border: `solid 5px ${ColorWhite}`,
  borderRadius: "10px",
  lg: {
    width: "25%"
  },
  md: {
    width: "50%"
  },
  overflow: "hidden",
  sm: {
    width: "100%"
  }
};
const BannerContainerStyles = {
  borderRadius: "10px",
  lg: {
    width: "25%"
  },
  md: {
    width: "50%"
  },
  overflow: "hidden",
  sm: {
    width: "100%"
  }
};
const CategoryContentStyles = {
  "> div": {
    flex: "50%",
    padding: "10px"
  },
  backgroundColor: ColorGray100,
  border: `solid ${SizeBorderWidthThin} ${ColorGray200}`,
  color: ColorGray900,
  display: "flex",
  flexWrap: "wrap",
  overflow: "hidden",
  padding: "0 5px 5px 5px",
  textAlign: "center"
};
const CategoryContent = styled(CostcoBox, {
  shouldForwardProp: (props) => props !== "isAdSetCostco"
})(
  ({ isAdSetCostco }) => isAdSetCostco ? {
    alignItems: "center",
    columnGap: SpaceXs,
    display: "grid",
    gridAutoFlow: "row",
    gridTemplateColumns: "repeat(2, auto)",
    padding: `0px ${SpaceXs} 0px ${SpaceXs}`,
    rowGap: SpaceXs
  } : {
    "> div": {
      flex: "50%",
      padding: "10px"
    },
    border: `solid ${SizeBorderWidthThin} ${ColorGray200}`,
    color: ColorGray900,
    display: "flex",
    flexWrap: "wrap",
    overflow: "hidden",
    padding: "0 5px 5px 5px",
    textAlign: "center"
  }
);
const BannerContentStyles = {
  "> div": {
    flex: {
      md: `calc(50% - ${SpaceLg})`,
      xs: `calc(50% - ${SpaceMd})`
    }
  },
  display: "flex",
  flexWrap: "wrap",
  gap: { md: SpaceLg, xs: SpaceMd },
  overflow: "hidden"
};
const CategoryHeadingStyles = {
  backgroundColor: "#eee",
  fontSize: FontSize600,
  fontWeight: FontWeightBold,
  lineHeight: 1.167,
  marginTop: "0px",
  minHeight: "50px",
  padding: "10px",
  textAlign: "center"
};
export {
  BannerContainerStyles,
  BannerContentStyles,
  CategoryContainerStyles,
  CategoryContent,
  CategoryContentStyles,
  CategoryHeadingStyles
};
